import script from "./popup_prosthesis_print.vue?vue&type=script&setup=true&lang=js"
export * from "./popup_prosthesis_print.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__